import { Injectable } from '@angular/core';
import { NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';

import { Observable, BehaviorSubject } from 'rxjs';
import { share, filter } from 'rxjs/operators';

@Injectable()
export class RouteSnapshotHistoryService {
  private _history: RouterStateSnapshot[] = [];
  private _subject = new BehaviorSubject<RouterStateSnapshot[]>(this._history);

  constructor(private _router: Router) {}

  start(): void {
    this._router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((_event: NavigationEnd) => {
        this.routeSnapshot(this._router.routerState.snapshot);
      });
  }

  getRouteSnapshotHistory(): Observable<RouterStateSnapshot[]> {
    return this._subject.asObservable().pipe(share());
  }

  routeSnapshot(routeSnapshot: RouterStateSnapshot): void {
    this._history.push(routeSnapshot);
    this._subject.next(this._history);
  }

  clear(): void {
    this._history.length = 0;
    this._subject.next(this._history);
  }
}
